import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class DistanceComponent extends Component {
  static readonly TYPE_ID: string = '02001e2d94bd460eaadcb605ce9bc00f';

  constructor(
    public readonly distance: number,
  ) {
    super();
  }

  get $typeId() {
    return DistanceComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): DistanceComponent {
    return new DistanceComponent(
        MapUtils.get<number>(map, 'distance'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'distance': this.distance,
    };
  }

  clone(): this {
    return new DistanceComponent(
        this.distance,
    ) as this;
  }

  isSame(other: DistanceComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.distance === this.distance;
  }
}

export class DistanceComponentBuilder extends DataModelBuilder<DistanceComponent> {
  build(context: SerializationContext, map: SerializedData): DistanceComponent {
    return DistanceComponent.fromMap(context, map);
  }
}
